

import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import ASIANAQUATICSLOGO from "../../../images/uk_logo.png";
import ASIANAQUATICSLOGO_COLLAPSED from "../../../images/AquaticsLogoCollapsed.png";

export function NavMenuToggle(callback) {
  setTimeout(() => {
    const mainwrapper = document.querySelector("#main-wrapper");
    if (!mainwrapper) return;

    const isNowCollapsed = mainwrapper.classList.toggle("menu-toggle");
    callback?.(isNowCollapsed);
  }, 300);
}

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const { navigationHader, background } = useContext(ThemeContext);

  useEffect(() => {
    const updateState = () => {
      const mainwrapper = document.querySelector("#main-wrapper");
      const isCollapsed = mainwrapper?.classList.contains("menu-toggle");
      setIsSidebarCollapsed(isCollapsed || screenWidth < 1024);
      setScreenWidth(window.innerWidth);
    };

    updateState();
    window.addEventListener("resize", updateState);
    return () => window.removeEventListener("resize", updateState);
  }, [screenWidth]);

  const showCollapsedLogo = screenWidth < 1024 || isSidebarCollapsed;

  return (
    <div className="nav-header" style={{ zIndex: 11 }}>
      <Link to="/" className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <img
              style={{
                objectFit: "contain",
                width: "100%",
                height: "100%",
                imageRendering: "auto",
                WebkitImageRendering: "auto",
                msInterpolationMode: "bicubic",
              }}
              height={55}
              width={55}
              src={
                showCollapsedLogo
                  ? ASIANAQUATICSLOGO_COLLAPSED
                  : ASIANAQUATICSLOGO
              }
              alt="logo"
            />
          </Fragment>
        ) : (
          <Fragment>
            <img
              style={{
                objectFit: "contain",
                width: "100%",
                height: "100%",
                imageRendering: "auto",
                WebkitImageRendering: "auto",
                msInterpolationMode: "bicubic",
              }}
              height={55}
              width={55}
              src={
                showCollapsedLogo
                  ? ASIANAQUATICSLOGO_COLLAPSED
                  : ASIANAQUATICSLOGO
              }
              alt="logo"
            />
          </Fragment>
        )}
      </Link>

      <div
        className="nav-control"
        onClick={() => {
          setToggle((prev) => !prev);
          NavMenuToggle(setIsSidebarCollapsed);
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
